<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn';
</script>

<template>
  <el-config-provider :locale="zhCn">
    <RouterView v-slot="{ Component, route }">
      <Transition name="app-fade" appear>
        <component :is="Component" :key="route.matched[0]?.path || route.path" />
      </Transition>
    </RouterView>
  </el-config-provider>
</template>
